import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { CategoryBaseFragmentDoc } from '../../fragments/__generated__/Category.generated';
import { CategoryBaseWithThumbnailFragmentDoc } from '../../fragments/__generated__/CategoryWithThumbnail.generated';
import { ReflectionBaseFragmentDoc } from '../../fragments/__generated__/Reflection.generated';
import { AttributeSchemaFragmentDoc } from '../../fragments/__generated__/AttributeSchema.generated';
import { FilterSchemaCategoryFragmentDoc } from '../../fragments/__generated__/FilterSchemaCategory.generated';
import { CategoryProductsCountFragmentDoc } from '../../fragments/__generated__/CategoryProductsCount.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CategoryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type CategoryQuery = { category: { relatedCount: number, id: string, name: string, url: string, pk: number, slug: string, description: string, metaDescription: string, keywords: string, metaTitle: string, level: number, isWholesale: boolean } | null };

export type CategoryListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CategoryListQuery = { categories: Array<{ thumbnailUrl: string | null, id: string, name: string, url: string, pk: number, slug: string, description: string, metaDescription: string, keywords: string, metaTitle: string, level: number, isWholesale: boolean, children: Array<{ thumbnailUrl: string | null, id: string, name: string, url: string, pk: number, slug: string, description: string, metaDescription: string, keywords: string, metaTitle: string, level: number, isWholesale: boolean, children: Array<{ thumbnailUrl: string | null, id: string, name: string, url: string, pk: number, slug: string, description: string, metaDescription: string, keywords: string, metaTitle: string, level: number, isWholesale: boolean }> }> }> };

export type MainCategoryListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MainCategoryListQuery = { categories: Array<{ thumbnailUrl: string | null, id: string, name: string, url: string, pk: number, slug: string, description: string, metaDescription: string, keywords: string, metaTitle: string, level: number, isWholesale: boolean }> };

export type CategoryListRandomSpecificsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CategoryListRandomSpecificsQuery = { categories: Array<{ id: string, randomSpecifics: { edges: Array<{ node: { absoluteUrl: string, id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string, product: { id: string, thumbnailUrl: string | null } | null } }> } }> };

export type ProductsFilterSchemaQueryVariables = Types.Exact<{
  category?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  price0?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  price1?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  collectionSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  q?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sale?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  skipCollections?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  skipAttributes?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  promoCode?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  attributes?: Types.InputMaybe<Array<Types.AttributeInputType> | Types.AttributeInputType>;
  isWholesale?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  cartToken?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  productIsMainRelated?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ProductsFilterSchemaQuery = { productsFilterSchema: { minPrice: number, maxPrice: number, attributes?: Array<{ id: string, name: string, dataType: Types.AttributeDataTypeEnum, widgetType: Types.AttributeWidgetTypeEnum, minValue: number, maxValue: number, isCollapsed: boolean, isPublished: boolean, values: Array<{ id: string, name: string, red: number, green: number, blue: number, publicName: string | null }> }>, collections?: Array<{ id: string, pk: number, name: string, slug: string }>, saleList: Array<{ id: string, pk: number, name: string, count: number }>, categories: Array<{ id: string, pk: number, parentId: number | null, name: string, slug: string, count: number, level: number }> } };

export type CategoriesProductsCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CategoriesProductsCountQuery = { categoriesProductsCount: Array<{ id: string, name: string, specCount: number }> };


export const CategoryDocument = gql`
    query Category($id: ID!) {
  category(id: $id) {
    ...CategoryBaseFragment
    relatedCount
  }
}
    ${CategoryBaseFragmentDoc}`;

/**
 * __useCategoryQuery__
 *
 * To run a query within a React component, call `useCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCategoryQuery(baseOptions: Apollo.QueryHookOptions<CategoryQuery, CategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryQuery, CategoryQueryVariables>(CategoryDocument, options);
      }
export function useCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryQuery, CategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryQuery, CategoryQueryVariables>(CategoryDocument, options);
        }
export type CategoryQueryHookResult = ReturnType<typeof useCategoryQuery>;
export type CategoryLazyQueryHookResult = ReturnType<typeof useCategoryLazyQuery>;
export type CategoryQueryResult = Apollo.QueryResult<CategoryQuery, CategoryQueryVariables>;
export function refetchCategoryQuery(variables: CategoryQueryVariables) {
      return { query: CategoryDocument, variables: variables }
    }
export const CategoryListDocument = gql`
    query CategoryList {
  categories {
    ...CategoryBaseWithThumbnailFragment
    children {
      ...CategoryBaseWithThumbnailFragment
      children {
        ...CategoryBaseWithThumbnailFragment
      }
    }
  }
}
    ${CategoryBaseWithThumbnailFragmentDoc}`;

/**
 * __useCategoryListQuery__
 *
 * To run a query within a React component, call `useCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
      }
export function useCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
        }
export type CategoryListQueryHookResult = ReturnType<typeof useCategoryListQuery>;
export type CategoryListLazyQueryHookResult = ReturnType<typeof useCategoryListLazyQuery>;
export type CategoryListQueryResult = Apollo.QueryResult<CategoryListQuery, CategoryListQueryVariables>;
export function refetchCategoryListQuery(variables?: CategoryListQueryVariables) {
      return { query: CategoryListDocument, variables: variables }
    }
export const MainCategoryListDocument = gql`
    query MainCategoryList {
  categories {
    ...CategoryBaseWithThumbnailFragment
  }
}
    ${CategoryBaseWithThumbnailFragmentDoc}`;

/**
 * __useMainCategoryListQuery__
 *
 * To run a query within a React component, call `useMainCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useMainCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<MainCategoryListQuery, MainCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainCategoryListQuery, MainCategoryListQueryVariables>(MainCategoryListDocument, options);
      }
export function useMainCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainCategoryListQuery, MainCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainCategoryListQuery, MainCategoryListQueryVariables>(MainCategoryListDocument, options);
        }
export type MainCategoryListQueryHookResult = ReturnType<typeof useMainCategoryListQuery>;
export type MainCategoryListLazyQueryHookResult = ReturnType<typeof useMainCategoryListLazyQuery>;
export type MainCategoryListQueryResult = Apollo.QueryResult<MainCategoryListQuery, MainCategoryListQueryVariables>;
export function refetchMainCategoryListQuery(variables?: MainCategoryListQueryVariables) {
      return { query: MainCategoryListDocument, variables: variables }
    }
export const CategoryListRandomSpecificsDocument = gql`
    query CategoryListRandomSpecifics {
  categories {
    id
    randomSpecifics: productSpecifics(filters: {siteSpecifics: true}, first: 3) {
      edges {
        node {
          ...ReflectionBaseFragment
          absoluteUrl
          product {
            id
            thumbnailUrl(size: "600x0", method: CROP_WEBP)
          }
        }
      }
    }
  }
}
    ${ReflectionBaseFragmentDoc}`;

/**
 * __useCategoryListRandomSpecificsQuery__
 *
 * To run a query within a React component, call `useCategoryListRandomSpecificsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListRandomSpecificsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListRandomSpecificsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoryListRandomSpecificsQuery(baseOptions?: Apollo.QueryHookOptions<CategoryListRandomSpecificsQuery, CategoryListRandomSpecificsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryListRandomSpecificsQuery, CategoryListRandomSpecificsQueryVariables>(CategoryListRandomSpecificsDocument, options);
      }
export function useCategoryListRandomSpecificsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryListRandomSpecificsQuery, CategoryListRandomSpecificsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryListRandomSpecificsQuery, CategoryListRandomSpecificsQueryVariables>(CategoryListRandomSpecificsDocument, options);
        }
export type CategoryListRandomSpecificsQueryHookResult = ReturnType<typeof useCategoryListRandomSpecificsQuery>;
export type CategoryListRandomSpecificsLazyQueryHookResult = ReturnType<typeof useCategoryListRandomSpecificsLazyQuery>;
export type CategoryListRandomSpecificsQueryResult = Apollo.QueryResult<CategoryListRandomSpecificsQuery, CategoryListRandomSpecificsQueryVariables>;
export function refetchCategoryListRandomSpecificsQuery(variables?: CategoryListRandomSpecificsQueryVariables) {
      return { query: CategoryListRandomSpecificsDocument, variables: variables }
    }
export const ProductsFilterSchemaDocument = gql`
    query ProductsFilterSchema($category: ID, $price0: Int, $price1: Int, $collectionSlug: String, $q: String, $sale: [ID!], $skipCollections: Boolean = false, $skipAttributes: Boolean = false, $promoCode: [ID!], $attributes: [AttributeInputType!], $isWholesale: Boolean, $cartToken: UUID, $productIsMainRelated: Boolean) {
  productsFilterSchema(
    category: $category
    price0: $price0
    price1: $price1
    collection: $collectionSlug
    q: $q
    product_Variants_Sales: $sale
    promoCode: $promoCode
    attributes: $attributes
    isWholesale: $isWholesale
    cartToken: $cartToken
    productIsMainRelated: $productIsMainRelated
  ) {
    minPrice
    maxPrice
    attributes @skip(if: $skipAttributes) {
      ...AttributeSchemaFragment
    }
    collections @skip(if: $skipCollections) {
      id
      pk
      name
      slug
    }
    saleList {
      id
      pk
      name
      count
    }
    categories {
      ...FilterSchemaCategory
    }
  }
}
    ${AttributeSchemaFragmentDoc}
${FilterSchemaCategoryFragmentDoc}`;

/**
 * __useProductsFilterSchemaQuery__
 *
 * To run a query within a React component, call `useProductsFilterSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsFilterSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsFilterSchemaQuery({
 *   variables: {
 *      category: // value for 'category'
 *      price0: // value for 'price0'
 *      price1: // value for 'price1'
 *      collectionSlug: // value for 'collectionSlug'
 *      q: // value for 'q'
 *      sale: // value for 'sale'
 *      skipCollections: // value for 'skipCollections'
 *      skipAttributes: // value for 'skipAttributes'
 *      promoCode: // value for 'promoCode'
 *      attributes: // value for 'attributes'
 *      isWholesale: // value for 'isWholesale'
 *      cartToken: // value for 'cartToken'
 *      productIsMainRelated: // value for 'productIsMainRelated'
 *   },
 * });
 */
export function useProductsFilterSchemaQuery(baseOptions?: Apollo.QueryHookOptions<ProductsFilterSchemaQuery, ProductsFilterSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsFilterSchemaQuery, ProductsFilterSchemaQueryVariables>(ProductsFilterSchemaDocument, options);
      }
export function useProductsFilterSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsFilterSchemaQuery, ProductsFilterSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsFilterSchemaQuery, ProductsFilterSchemaQueryVariables>(ProductsFilterSchemaDocument, options);
        }
export type ProductsFilterSchemaQueryHookResult = ReturnType<typeof useProductsFilterSchemaQuery>;
export type ProductsFilterSchemaLazyQueryHookResult = ReturnType<typeof useProductsFilterSchemaLazyQuery>;
export type ProductsFilterSchemaQueryResult = Apollo.QueryResult<ProductsFilterSchemaQuery, ProductsFilterSchemaQueryVariables>;
export function refetchProductsFilterSchemaQuery(variables?: ProductsFilterSchemaQueryVariables) {
      return { query: ProductsFilterSchemaDocument, variables: variables }
    }
export const CategoriesProductsCountDocument = gql`
    query CategoriesProductsCount {
  categoriesProductsCount {
    ...CategoryProductsCountFragment
  }
}
    ${CategoryProductsCountFragmentDoc}`;

/**
 * __useCategoriesProductsCountQuery__
 *
 * To run a query within a React component, call `useCategoriesProductsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesProductsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesProductsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoriesProductsCountQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesProductsCountQuery, CategoriesProductsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesProductsCountQuery, CategoriesProductsCountQueryVariables>(CategoriesProductsCountDocument, options);
      }
export function useCategoriesProductsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesProductsCountQuery, CategoriesProductsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesProductsCountQuery, CategoriesProductsCountQueryVariables>(CategoriesProductsCountDocument, options);
        }
export type CategoriesProductsCountQueryHookResult = ReturnType<typeof useCategoriesProductsCountQuery>;
export type CategoriesProductsCountLazyQueryHookResult = ReturnType<typeof useCategoriesProductsCountLazyQuery>;
export type CategoriesProductsCountQueryResult = Apollo.QueryResult<CategoriesProductsCountQuery, CategoriesProductsCountQueryVariables>;
export function refetchCategoriesProductsCountQuery(variables?: CategoriesProductsCountQueryVariables) {
      return { query: CategoriesProductsCountDocument, variables: variables }
    }